import { AxiosInstance } from 'axios';

export abstract class BaseServiceClient {
  public requestConfig: { baseURL: string };
  constructor(public httpClient: AxiosInstance, public baseUrl: string, public apiVersion: string = 'v1') {
    this.requestConfig = {
      baseURL: `${baseUrl}/${apiVersion}`,
    };
  }
}
